import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Mobile from '../../Responsive/Mobile';
import Desktop from '../../Responsive/Desktop';
import Tooltip from '../../Tooltip';
import styles from './index.scss';

const serialNumberImg = require('../../../../assets/images/serial_number.svg');
const modelNumberImg = require('../../../../assets/images/model_number.svg');

class AddedUPSList extends Component {
    handleDeleteAction = e => {
        const { index } = e.target.dataset;
        this.props.deleteUps(index);
    };

    renderAddedUpsDesktop(tradeUpsItem, index) {
        const { tradeUps } = this.props;
        const rowItemClasses = classNames(styles.upsListTableCell, styles.wrappedOption);
        const bigCellClasses = classNames(rowItemClasses, styles.upsListTableCellBig);
        const middleCellClasses = classNames(rowItemClasses, styles.upsListTableCellMiddle);
        const smallCellClasses = classNames(rowItemClasses, styles.upsListTableCellSmall);

        return tradeUps.map((tradeUpsItem, index) => {
            const row = [];
            row.push(
                <div key={index} className={`${styles.upsListTableRow} ${styles.upsListRow}`}>
                    <div className={classNames(bigCellClasses, 'analytics-manufacture')}>
                        <span>{tradeUpsItem[0]}</span>
                    </div>
                    <div className={classNames(bigCellClasses, 'analytics-sku')}>{tradeUpsItem[1]}</div>
                    <div className={bigCellClasses}>{tradeUpsItem[2]}</div>
                    <div className={middleCellClasses}>
                        <div> {tradeUpsItem[3]} </div>
                    </div>
                    <div className={middleCellClasses}>
                        <div> {tradeUpsItem[4]} </div>
                    </div>
                    <div className={smallCellClasses}>
                        <div className={styles.deleteAction}>
                            <i className={styles.deleteIcon} data-index={index} onClick={this.handleDeleteAction} />
                        </div>
                    </div>
                </div>,
            );
            return row;
        });
    }

    renderUpsRowMobile() {
        const { tradeUps } = this.props;
        return tradeUps.map((ups, index) => {
            const row = [];

            row.push(
                <div className={styles.UspCard}>
                    <div>
                        <p className={styles.UpsBrand}>{ups[0]}</p>
                        <p className={styles.UpsDescription}>
                            <span>
                                <FormattedMessage id="tradeUps_modelSku" />
                            </span>{' '}
                            <span>{ups[1]}</span>
                        </p>
                        <p className={styles.UpsDescription}>
                            <span>
                                <FormattedMessage id="tradeUps_serialNo" />
                            </span>{' '}
                            <span>{ups[2]}</span>
                        </p>
                        <p className={styles.UpsDescription}>
                            <span>
                                <FormattedMessage id="tradeUps_capacity" />
                            </span>{' '}
                            <span>{ups[3]} </span>
                        </p>
                        <p className={styles.UpsDescription}>
                            <span>
                                <FormattedMessage id="tradeUps_weight" />
                            </span>{' '}
                            <span>{ups[4]}</span>
                        </p>
                    </div>
                    <div className={styles.deleteAction}>
                        <i className={styles.deleteIcon} data-index={index} onClick={this.handleDeleteAction} />
                    </div>
                </div>,
            );
            return row;
        });
    }

    render() {
        return (
            <React.Fragment>
                <Desktop>
                    <div className={styles.upsListTableRow}>
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellBig}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id="tradeUps_upsManufacturer" />
                            </label>
                        </div>
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellBig}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id="tradeUps_modelSku" />
                                <Tooltip
                                    extraClass="m-l-5"
                                    delayTime={500}
                                    tooltipImagePath={modelNumberImg}
                                    tooltipMobileHeader=""
                                    tooltipText="tradeUps_tooltipModelNumber"
                                />
                            </label>
                        </div>
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellBig}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id="tradeUps_serialNo" />
                                <Tooltip
                                    extraClass="m-l-5"
                                    delayTime={500}
                                    tooltipImagePath={serialNumberImg}
                                    tooltipMobileHeader=""
                                    tooltipText="tradeUps_tooltipSerialNumber"
                                />
                            </label>
                        </div>
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellMiddle}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id="tradeUps_capacity" />
                            </label>
                        </div>
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellMiddle}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id="tradeUps_weight" />
                            </label>
                        </div>
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellSmall}`}>
                            <label className={styles.formGroupLabel} />
                        </div>
                    </div>
                    {this.renderAddedUpsDesktop()}
                </Desktop>
                <Mobile>{this.renderUpsRowMobile()}</Mobile>
            </React.Fragment>
        );
    }
}

AddedUPSList.propTypes = {
    tradeUps: PropTypes.array.isRequired,
    deleteUps: PropTypes.func.isRequired,
};

export default AddedUPSList;
